import script from "./name-tag.vue?vue&type=script&lang=ts&setup=true"
export * from "./name-tag.vue?vue&type=script&lang=ts&setup=true"

import "./name-tag.vue?vue&type=style&index=0&id=118a9f99&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-118a9f99"]])

export default __exports__